export const TOKEN_KEY = 'loloyal-shop-token'
export const ADD_PLAN_CHARGE_ID = 'add-plan-charge-id'

export const enum EmitKeyMap {
  EditDataUpdate = 'editDataUpdate',

  Publish = 'Publish',
  Refetch = 'Refetch',
}

export const PLAN_NAMES = {
  Free: 'Free',
  FreeEasterEgg: 'Free easter egg',
  FreeUnlocked: 'Free unlocked',
  Starter: 'Starter',
  Growth: 'Growth',
  Plus: 'Plus',
}

export const PLANS_ORDER_LIMITED = {
  Free: 25,
  FreeEgg: 50,
}

export const INTERVALS = {
  every_30_days: 'every_30_days',
  EVERY_30_DAYS: 'EVERY_30_DAYS',
  annual: 'annual',
  ANNUAL: 'ANNUAL',
}

// 店铺创建时间是否早于上线时间  1681209000 2023-04-11 18:30:00
export const SHOP_ONLINE_TIME = 1681209000
// 上线V7.2.1版本的时间：2024-10-29 18:30:00，时间戳：1730197800
// 上线后的新用户不展示优惠券模块，只有历史用户已存在的营销事件（历史营销事件），在编辑的时候，才展示优惠券模块，新建同样隐藏
export const VERSION_ONLINE_TIME = 1730197800

// 调起willdesk客服弹窗预置文案
export const WILLDESK_PRESET_CONTENT = {
  unlock:
    "👋Hi.  I'd like to unlock the experience of the Loloyal loyalty program (worth $29 per month) 😀.",
}

// 全局 API 报错的 key
export const GLOBAL_API_ERROR = 'global-api-error'
export const GLOBAL_API_REQUEST_ID = 'x-ll-request-id'
